module.exports = __webpack_public_path__ + "img/Patent_4.a5ae42f8.jpg";